import axios from "axios";
import axiosInstance from "../../utils/axiosInstance";
import { BASE_URL } from "../../constant/staticUrl";
const API = axios.create({ baseURL: BASE_URL });

// for  packages
export const getAllpackageApi = (formData) =>
  axiosInstance.get(`/admin/packages/get-all`, formData);

export const createpackageApi = (formData) =>
  axiosInstance.post(`/admin/packages/create`, formData);

export const deletepackageApi = (id) =>
  axiosInstance.delete(`/admin/packages/delete/${id}`);

export const updatepackageApi = (id, formData) =>
  axiosInstance.post(`/admin/packages/update/${id}`, formData);

// for  subjects
export const getAllSubjectApi = (formData) =>
  axiosInstance.get(`/admin/subject/get-all`, formData);

export const createSubjectApi = (formData) =>
  axiosInstance.post(`/admin/subject/create`, formData);

export const deleteSubjectApi = (id) =>
  axiosInstance.delete(`/admin/subject/delete/${id}`);

export const updateSubjectApi = (id, formData) =>
  axiosInstance.post(`/admin/subject/update/${id}`, formData);

// for chapters
export const getAllChapterApi = (formData) =>
  axiosInstance.get(`/admin/chapter/get-all`, formData);

export const createChapterApi = (formData) =>
  axiosInstance.post(`/admin/chapter/create`, formData);

export const updateChapterApi = (id, formData) =>
  axiosInstance.post(`/admin/chapter/update/${id}`, formData);

export const deleteChapterApi = (id) =>
  axiosInstance.delete(`/admin/chapter/delete/${id}`);

//  for topic  crud
export const getAllTopicApi = (formData) =>
  axiosInstance.get(`/admin/topic/get-all`, formData);

export const createTopicApi = (formData) =>
  axiosInstance.post(`/admin/topic/create`, formData);

export const updateTopicApi = (id, formData) =>
  axiosInstance.post(`/admin/topic/update/${id}`, formData);

export const deleteTopicApi = (id) =>
  axiosInstance.delete(`/admin/topic/delete/${id}`);

// for subtopic
export const getAllSubtopicApi = (formData) =>
  axiosInstance.get(`/sub-topic/get-all`, formData);
